import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    sectionCurrent: 0,
    mgMenu: 'none',
    showMenu: false,
    hiddenMenu: true,
  },
  mutations: {
    increment (state) {
      state.sectionCurrent++
    },
    decrement (state) {
      state.sectionCurrent--
    },
    changeCurrent (state, item) {
      state.sectionCurrent = item
    },
    showSection (state) {
      state.mgMenu = 'block'
      state.showMenu = true
      state.hiddenMenu = false
    },
    hiddenSection (state) {
      state.mgMenu = 'none'
      state.showMenu = false
      state.hiddenMenu = true
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/config/store.js